import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { fileService, type FileRecord, type ListRecordsResponse } from '../services/file.service';

export function useFiles(sourceRecordTypeId: string | null | undefined) {
  return useQuery<ListRecordsResponse<FileRecord>>({
    queryKey: ['files', sourceRecordTypeId],
    queryFn: () => {
      return fileService.find({
        source_record_type_id: { $eq: sourceRecordTypeId },
      });
    },
    enabled: !!sourceRecordTypeId,
    staleTime: 30 * 1000,
  });
}

export function useDeleteFile() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ nodeId, fileId }: { nodeId: string; fileId: string }) =>
      fileService.deleteFromNode(nodeId, fileId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['files'] });
    },
  });
}
